var map = {
	"./BOOEVILUTION7.png": 5792,
	"./Hero Fight 2.png": 581,
	"./Hero Fight.png": 8176,
	"./Inosuke Red.png": 7202,
	"./Luffy Gear Five.png": 556,
	"./adan.png": 7692,
	"./buda final .png": 1590,
	"./demon slayer 01.png": 8450,
	"./logoNami.png": 2675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8514;